export interface PublicLocationRequest {
  searchParam: string | null;
  productIds: string[] | null;
  tagIds: string[] | null;
}
